import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import BButton from 'JS/components/BButton.vue';
import { ref } from 'vue';
import { useDistanceFromTop } from '../composables/distance-from-top';


export default /*#__PURE__*/_defineComponent({
  __name: 'SalesFlyerNoAds',
  setup(__props) {

_useCssVars((_vm, _setup) => ({
  "7e3749d6": (_setup.distanceFromTop)
}))

const el = ref<HTMLElement | null>(null);
const { distanceFromTop } = useDistanceFromTop(el);


return { __sfc: true,el, distanceFromTop, BButton }
}

})